import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from '@angular/core';

/**
 * `<labs-header-bar>` displays a header bar
 */
@Component({
  selector: 'labs-header-bar',
  templateUrl: './header-bar.component.html',
  styleUrls: ['./header-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HeaderBarComponent {
  @Input() menuVisible = false;

  @Input() menuColor: 'primary' | 'accent' | undefined;

  @Output() menuClick = new EventEmitter<void>();
}
